export default "__VITE_ASSET__6ic7QqqN__"